<template>
    <div id="role3_list">
        <div class="header">
            <span>选择账号</span>
            <van-icon name="cross" color="#000" @click="close" />
        </div>
        <div class="role_area">
            <div class="role_box">
                <div v-for="(item,i) in selection.roleList" :key="i">
                    <div class="account" @click="choose(item.id, item.game_account)" v-if="!item.child_list">
                        <p class="acc_left">账号：<span>{{ item.game_account }}</span></p>
                        <p class="acc_right">选择角色 <van-icon name="arrow" color="#a4a4a4"/></p>
                    </div>
                    <div class="account account2" v-else>
                        <p class="acc_left">账号：<span>{{ item.game_account }}</span></p>
                    </div>
                    <div class="roles" v-if="item.child_list && item.child_list.length">
                        <div class="role_item can" v-for="(its,k) in item.child_list" :key="k" @click="choose(item.id, item.game_account, its.jh_user_id)">
                            <span>{{ its.nickname }}</span>
                            <van-icon name="arrow" color="#a4a4a4"/>
                        </div>
                    </div>
                </div>
                <div class="addmoreacc" @click="bindmorerole">
                    <van-icon name="add-o" color="#A4A4A4" />
                    绑定更多账号
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {

            };
        },
        props: ['selection'],
        computed: {
            server_id() {
                return this.$store.state.home_server_id
            }
        },
        mounted() {

        },
        methods: {
            close() {
                // this.$emit('handleSuccess',{id: 0})
                this.$parent.handleClose()
            },
            choose(role_id, game_account, child_user_id) {
                const payload = {
                    role_id,
                    game_account
                }
                if (child_user_id) {
                    payload.child_user_id = child_user_id
                }
                this.$emit('handleSuccess', payload)
                this.$parent.handleClose()
            },
            bindmorerole() {
                this.$router.push({
                    name: 'user.bindrole'
                })
            }
        },
    };
</script>
<style lang="less" scoped>
    #role3_list {
        height: calc(var(--vh, 1)*60);
        background-color: #fbfbfb;
        display: flex;
        flex-direction: column;

        .header {
            height: 5.6rem;
            padding-top: 2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            font-size: 1.6rem;
            font-weight: 700;
            .van-icon {
                position: absolute;
                right: 1rem;
                top: 1rem;
                font-size: 1.8rem;
                cursor: pointer;
            }
        }

        .role_area {
            flex: 1;
            padding: 0 1rem;
            overflow-y: auto;
            .role_box {
                border-radius: 1rem;
                overflow: hidden;
                background-color: #fff;
                padding: 0 1.8rem;
                .account {
                    height: 5.2rem;
                    padding-left: .5rem;
                    color: #a4a4a4;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border-bottom: 1px solid #f2f2f2;
                    cursor: pointer;
                    &:last-child {
                        border-bottom: none;
                    }
                    .acc_left {
                        font-size: 1.6rem;
                        span {
                            color: #000;
                        }
                    }
                    .acc_right {
                        font-size: 1.4rem;
                    }
                    &:hover {
                        .acc_right {
                            color: var(--theme);
                            /deep/.van-icon {
                                color: var(--theme) !important;
                            }
                        }
                    }
                }
                .account2 {
                    border-top-left-radius: 1rem;
                    border-top-right-radius: 1rem;
                    background: url(../../assets/version_1.3.0/sell/money.png) no-repeat 100% 0 / 5.8rem 6.1rem;
                    background-color: #FFE4D8;
                    overflow: hidden;
                    color: #000;
                    padding-left: 1rem;
                    height: 4.5rem;
                }
                .roles {
                    .role_item {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0.8rem 1rem;
                        border: 1px solid rgba(246, 111, 48, 0.3);
                        border-radius: 1rem;
                        margin-bottom: .9rem;
                        font-size: 1.3rem;
                        color: #000;
                        cursor: pointer;
                        &.can {
                            background-color: #fff;
                            color: #000;
                        }
                        &.choosed {
                            background-color: var(--themebgc);
                            color: var(--fade5);
                        }
                    }
                }
            }
        }
        .addmoreacc {
            height: 4rem;
            color: #a4a4a4;
            font-size: 1.6rem;
            display: flex;
            align-items: center;
            cursor: pointer;
            .van-icon {
                font-size: 1.8rem;
                font-weight: 700;
                margin-right: 1.2rem;
                margin-top: .2rem;
            }
            &:hover {
                color: var(--theme);
                /deep/.van-icon {
                    color: var(--theme) !important;
                }
            }
        }
    }
</style>
